import React, { useState, useEffect } from 'react'
import './csc.css'
import './bookings.css'
import axios from "axios";
import { APIURL } from "../../../Global";
import BookingSelection from './BookingsSelection'
import moment from 'moment';
import { useAlert } from 'react-alert';
import { useNavigate, useLocation } from 'react-router-dom';
const Appointments = () => {
    const location = useLocation();
    const from = location.state?.from || "";
    const userData = JSON.parse(sessionStorage.getItem("logindatas"));
    const role = userData.role
    const alliedId = userData.allied_id ? userData.allied_id : ''
    const doctorId = userData.user_id ? userData.user_id : ''
    const [selectedDate, setSelectedDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [selected, setSelected] = useState(null);
    const [selectedItem, setSelectedItem] = useState('');
    const [itemList, setItemList] = useState([])
    const [reload, setReload] = useState(false)
    const [searchName, setSearchName] = useState('');
    const currentDate = moment(new Date()).format('YYYY-MM-DD');
    const navigate = useNavigate()
    const [access, setAccess] = useState(JSON.parse(sessionStorage.getItem("access")))

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (role !== 'alliedprofessional' && access.some(item => ["0.1.8.1"].includes(item.node_access))) {
            setSelected("GeneralOp")
        } else if (role !== 'alliedprofessional' && access.some(item => ["0.1.1.2"].includes(item.node_access))) {
            setSelected("DialysisOp")
        } else if ((role !== 'alliedprofessional' && access.some(item => ["0.1.2.2"].includes(item.node_access)))) {
            setSelected("PalliativeOp")
        } else if (role !== 'nurse' && access.some(item => ["0.1.3.2"].includes(item.node_access))) {
            setSelected("PhysioOp")
        }
    }, [access, role])

    useEffect(() => {
        setItemList([])
        if (selected === "GeneralOp" || selected === 'PalliativeOp') {
            const tokenString = sessionStorage.getItem("usertoken");
            let str = tokenString.replace(/["]+/g, "");
            const doctor_id = doctorId;
            const endpoint = (selected === "GeneralOp") ? `booking/?date=${selectedDate}&status=success&service_status=pending&doctor_id=${doctor_id}`
                : `booking/?is_palliative=true&date=${selectedDate}&status=success&service_status=pending&doctor_id=${doctor_id}`
            axios
                .get(`${APIURL}/api/v1/patient/appointments/${endpoint} `, {
                    headers: {
                        Authorization: "Token " + str,
                    },
                })
                .then((res) => {

                    if (res.data.status === "success") {
                        let messageList = res.data.appointments ? res.data.appointments.map(item => ({ ...item, status: 'success' })) : [];
                        if (role !== "doctor") {
                            let cancelledList = res.data.cancelled_appointments ? res.data.cancelled_appointments.map(item => ({ ...item, status: 'cancelled' })) : [];
                            let mergedList = [...messageList, ...cancelledList];
                            setItemList(mergedList);
                        } else {
                            setItemList(messageList)
                        }
                    }
                    else {
                    }
                })
                .catch((err) => {
                });
        } else if (selected === "DialysisOp") {
            const tokenString = sessionStorage.getItem("usertoken");

            let str = tokenString.replace(/["]+/g, "");

            axios
                .get(`${APIURL}/api/v1/service-provider/dialysis-bookings/?date=${selectedDate} `, {
                    headers: {
                        Authorization: "Token " + str,
                    },
                })
                .then((res) => {

                    if (res.data.status === "success") {
                        let messageList = res.data.message ? res.data.message.map(item => ({ ...item, status: 'success' })) : [];
                        let cancelledList = res.data.cancelled_appointment ? res.data.cancelled_appointment.map(item => ({ ...item, status: 'cancelled' })) : [];
                        let mergedList = [...messageList, ...cancelledList];
                        setItemList(mergedList);
                    }
                    else {
                    }
                })
                .catch((err) => {
                });
        }
        else if (selected === 'PhysioOp') {
            const tokenString = sessionStorage.getItem("usertoken");
            let str = tokenString.replace(/["]+/g, "");
            const allied_id = alliedId;
            const endpoint = `allied-bookings/?date=${selectedDate}&status=success&service_status=pending&allied_id=${allied_id}`
            axios
                .get(`${APIURL}/api/v1/service-provider/${endpoint}`, {
                    headers: {
                        Authorization: "Token " + str,
                    },
                })
                .then((res) => {

                    if (res.data.status === "success") {
                        let messageList = res.data.message || [];
                        let cancelledList = res.data.cancelled_appointmnet || [];
                        let mergedList = [...messageList, ...cancelledList];
                        setItemList(mergedList);
                    }
                    else {
                    }
                })
                .catch((err) => {
                });
        }

    }, [selectedDate, selected, reload])

    const filteredList = searchName === '' ? itemList : itemList.filter(item => {
        const nameToMatch = selected === 'GeneralOp' ? item.patient_name : item.patient;
        return nameToMatch?.toLowerCase().includes(searchName.toLowerCase());
    });

    return (
        <div className='csc-primary-container'>
            <BookingSelection
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                selected={selected}
                setReload={setReload}
                reload={reload}
                role={role}
                from={from}
            />
            <div className="col-lg-9 col-md-9 container">
                <div className='bookings'>
                    <div className='bookings-buttoncontainer'>
                        {role !== "alliedprofessional" && <>
                            {access.some(item => ["0.1.8.1"].includes(item.node_access)) && <button className={(selected === "GeneralOp") ? 'color-change' : ''} onClick={() => { setSelected("GeneralOp"); setSelectedItem('') }}>General Op</button>}
                            {((role !== 'doctor') && access.some(item => ["0.1.1.2"].includes(item.node_access))) && <button className={(selected === "DialysisOp") ? 'color-change' : ''} onClick={() => { setSelected("DialysisOp"); setSelectedItem('') }}>Dialysis Op</button>}
                            {access.some(item => ["0.1.2.2"].includes(item.node_access)) && <button className={(selected === "PalliativeOp") ? 'color-change' : ''} onClick={() => { setSelected("PalliativeOp"); setSelectedItem('') }}>Palliative Ip</button>}
                        </>}
                        {((role === 'bdo' || role === 'alliedprofessional' || role === 'front_office') && access.some(item => ["0.1.3.2"].includes(item.node_access))) && <button className={(selected === "PhysioOp") ? 'color-change' : ''} onClick={() => { setSelected("PhysioOp"); setSelectedItem('') }}>Physio Op</button>}
                        <div style={{ flex: 3 }}></div>
                    </div>
                    <div style={{ display: 'flex', margin: " 5px 0px" }}>
                        <div className='input-container-booking col-6'>
                            <label>Name</label>
                            <div className='input1' style={{ display: 'flex', backgroundColor: '#fff' }}>
                                <svg style={{}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.3851 15.4461C13.0371 16.5232 11.3278 17.0432 9.60827 16.8994C7.88877 16.7556 6.28961 15.9588 5.13922 14.6728C3.98883 13.3867 3.37455 11.709 3.42254 9.98415C3.47052 8.25932 4.17713 6.61834 5.39725 5.39822C6.61736 4.17811 8.25835 3.4715 9.98318 3.42351C11.708 3.37553 13.3857 3.98981 14.6718 5.1402C15.9579 6.29058 16.7546 7.88975 16.8984 9.60924C17.0422 11.3287 16.5222 13.038 15.4451 14.3861L20.6011 19.5411C20.6748 19.6097 20.7339 19.6925 20.7749 19.7845C20.8159 19.8765 20.8379 19.9758 20.8397 20.0765C20.8415 20.1772 20.8229 20.2773 20.7852 20.3707C20.7475 20.4641 20.6913 20.5489 20.6201 20.6201C20.5489 20.6913 20.4641 20.7475 20.3707 20.7852C20.2773 20.8229 20.1773 20.8414 20.0766 20.8397C19.9759 20.8379 19.8766 20.8158 19.7846 20.7748C19.6926 20.7339 19.6098 20.6748 19.5411 20.6011L14.3851 15.4461ZM6.46009 13.8841C5.72613 13.15 5.22624 12.2149 5.0236 11.1968C4.82096 10.1788 4.92466 9.1235 5.3216 8.16437C5.71854 7.20523 6.3909 6.38529 7.2537 5.80817C8.11651 5.23105 9.13103 4.92265 10.1691 4.92195C11.2071 4.92125 12.222 5.22828 13.0856 5.80424C13.9492 6.3802 14.6226 7.19924 15.0209 8.15784C15.4191 9.11644 15.5242 10.1716 15.323 11.1899C15.1217 12.2082 14.6231 13.144 13.8901 13.8791L13.8851 13.8841L13.8801 13.8881C12.8952 14.8707 11.5605 15.4222 10.1693 15.4214C8.77801 15.4207 7.44394 14.8678 6.46009 13.8841Z" fill="#777777" />
                                </svg>
                                <input className=''
                                    style={{ border: 'none', width: '100%' }}
                                    placeholder='Search Patient...'
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)} />

                            </div>
                        </div>
                    </div>
                    <div className='booklist-container' >
                        {((selected === 'GeneralOp' || selected === 'PalliativeOp') && filteredList.length > 0) ? (
                            <div>
                                <div style={{ display: 'flex', padding: '0px 15px' }}>
                                    <label className='col-3'>Patient</label>
                                    <label className='col-3'>Time slot</label>
                                    <label className='col-3'>Token</label>
                                    <label className='col-3'></label>
                                </div>
                                {filteredList.map((item, index) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className='bookingslist'
                                        >
                                            <div className='col-3'>
                                                <label className="head-style" style={{ textTransform: 'capitalize' }}> {item.patient_name}</label>
                                            </div>
                                            <div className='col-3'>
                                                <label className="head-style"> {item.slot}</label>
                                            </div>
                                            <div className='col-3'>
                                                <label className="head-style">Token &nbsp;{item.token}</label>
                                            </div>
                                            <div className='col-3'>
                                                {selectedDate === currentDate && <button className='records-butn' onClick={() => { navigate(`/patient-record/id/${item.patient_id}/mob/${item.mobile_number}`) }}>Go to Records</button>}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : ((selected === 'PhysioOp') && filteredList.length > 0) ? (
                            <div>
                                <div style={{ display: 'flex', padding: '0px 15px' }}>
                                    <label className='col-3'>Patient</label>
                                    <label className='col-3'>Time Slot</label>
                                    <label className='col-3'>Token</label>
                                    <label className='col-3'>Add Info</label>
                                </div>
                                {filteredList.map((item, index) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className='bookingslist'
                                        >
                                            <div className='col-3'>
                                                <label className="head-style" style={{ textTransform: 'capitalize' }}> {item.patient}</label>
                                            </div>
                                            <div className='col-3'>
                                                <label className="head-style"> {item.from_time}&nbsp;-&nbsp;{item.to_time}</label>
                                            </div>
                                            <div className='col-3'>
                                                <label className="head-style">Token &nbsp;{item.token}</label>
                                            </div>
                                            <div className='col-3'>
                                                {selectedDate === currentDate && <button className='records-butn' onClick={() => { navigate(`/patient-record/id/${item.patient_id}/mob/${item.mobile_number}`) }}>Go to Records</button>}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : <div className="" style={{ textAlign: 'center', margin: "10%", color: "red" }}>No Appointments!!</div>
                        }
                    </div>
                </div>
            </div>

        </div >
    )
}
export default Appointments